module.exports = __webpack_public_path__ + "static/media/ambassador-third.54ad8363.jpg";